export default __webpack_public_path__ + "static/media/tick.d4aeb63c.svg";